import { BaseServices, HttpMethod } from '@services/base'

import { FinalizarPropostaType } from './postPropostaFinalizarAppService'

export default async (_data: FinalizarPropostaType, accessToken?: string) => {
  const pathname = process.env.REACT_APP_PROPOSTA_FINALIZAR_WEB
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  }

  const response = await BaseServices.request({
    headers,
    pathname,
    method,
    host,
  })
  return response
}
